export default __webpack_public_path__ + "static/media/blackboard.d2460bfc.svg";